import { SocialPlatform, instagramLoginType, type SocialConnection } from '@mg/shared';
import { platformName } from './platforms';

/**
 * Connected, but the stored sign-in is dead: it hard-failed refresh (e.g. an X refresh token revoked
 * when the same account re-authorized the same app elsewhere), a platform refused a publish with it
 * as expired or revoked, or its sign-in has ended with nothing to renew it (the API works that out
 * from its end date). Nothing publishes through it until it is reconnected.
 *
 * The Connections page's "Reconnect needed" and the composer's note under Platform both ask here, so
 * they cannot disagree.
 */
export function reconnectNeeded(conn: SocialConnection): boolean {
  return conn.connected && conn.needsReconnect === true;
}

/**
 * The service whose sign-in page this account's Reconnect opens (POST /social/connections/:id/
 * reconnect starts the same flow the account was connected with), by the name it goes by.
 *
 *  - An Instagram account connected through Facebook signs in again with Facebook Login. Told apart
 *    by the permissions it stores, with the test the server's reconnect uses (`pages_show_list`).
 *  - Every other account: its platform's name ({@link platformName}: X signs in on "X", not on its
 *    display name "X / Twitter").
 */
export function reconnectSignInName(conn: SocialConnection): string {
  if (conn.platform === SocialPlatform.INSTAGRAM && instagramLoginType(conn.scopes) === 'facebook') {
    return platformName(SocialPlatform.FACEBOOK);
  }
  return platformName(conn.platform);
}
